import React from 'react';

import svgIcon from 'components/hoc/svgIcon';

const svg = (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Atom / Icon / General / Logout</title>
    <g id="Atom-/-Icon-/-General-/-Logout" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M19.9999,6.9997 C24.6149,6.9997 28.9239,9.4897 31.2469,13.4987 C31.5239,13.9767 31.3599,14.5887 30.8829,14.8647 C30.4019,15.1427 29.7929,14.9797 29.5159,14.5007 C27.5499,11.1087 23.9039,8.9997 19.9999,8.9997 C13.9349,8.9997 8.9999,13.9347 8.9999,19.9997 C8.9999,26.0657 13.9349,30.9997 19.9999,30.9997 C23.9059,30.9997 27.5509,28.8927 29.5139,25.4997 C29.7899,25.0227 30.4019,24.8587 30.8799,25.1357 C31.3589,25.4117 31.5219,26.0237 31.2449,26.5017 C28.9259,30.5097 24.6179,32.9997 19.9999,32.9997 C12.8319,32.9997 6.9999,27.1677 6.9999,19.9997 C6.9999,12.8317 12.8319,6.9997 19.9999,6.9997 Z M23.293,15.293 C23.684,14.902 24.316,14.902 24.707,15.293 L24.707,15.293 L28.707,19.293 C29.098,19.684 29.098,20.316 28.707,20.707 L28.707,20.707 L24.707,24.707 C24.512,24.902 24.256,25 24,25 C23.744,25 23.488,24.902 23.293,24.707 C22.902,24.316 22.902,23.684 23.293,23.293 L23.293,23.293 L25.586,21 L15,21 C14.448,21 14,20.553 14,20 C14,19.447 14.448,19 15,19 L15,19 L25.586,19 L23.293,16.707 C22.902,16.316 22.902,15.684 23.293,15.293 Z"
        id="Combined-Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);

export default svgIcon(svg);
